import { TAB_TYPE } from '@/types/pages/storeManagement/registration/registrationTypes';
import { Box, Paper } from '@mui/material';
import DeviceStepButton from './DeviceStepButton';
import { REGISTER_STEPS } from '../constants';

type DeviceStepSwitcherProps = {
    activeStep: number;
    lockedStepMap: Record<TAB_TYPE, boolean>;
    canSwitchStep: (step: TAB_TYPE) => boolean;
    onStepChange: (stepIndex: number) => void;
};

const DeviceStepSwitcher = ({ activeStep, lockedStepMap, canSwitchStep, onStepChange }: DeviceStepSwitcherProps) => {
    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: 2,
                border: '1px solid #E5E7EB',
                bgcolor: '#FFFFFF',
                px: 1.5,
                py: 1.25,
            }}
        >
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: '44px 1fr 44px 1fr 44px',
                    alignItems: 'start',
                    width: '100%',
                }}
            >
                {REGISTER_STEPS.map((step, index) => {
                    const active = activeStep === index;
                    const locked = lockedStepMap[step.key];
                    const switchable = canSwitchStep(step.key);

                    return (
                        <Box
                            key={step.key}
                            sx={{
                                display: 'contents',
                            }}
                        >
                            <DeviceStepButton
                                label={step.label}
                                active={active}
                                locked={locked}
                                switchable={switchable}
                                onClick={() => onStepChange(index)}
                            />

                            {index < REGISTER_STEPS.length - 1 && (
                                <Box
                                    sx={{
                                        height: '3px',
                                        bgcolor: lockedStepMap[REGISTER_STEPS[index + 1].key] ? '#E2E8F0' : '#CBD5E1',
                                        mt: '18px',
                                        mx: 1,
                                    }}
                                />
                            )}
                        </Box>
                    );
                })}
            </Box>
        </Paper>
    );
};

export default DeviceStepSwitcher;
